<template>
  <v-form ref="cardForm" :id="'videoCard'+id" v-model="valid">
    <v-row>
      <v-col cols="12">
        <v-card-text>
          <v-text-field clearable label="Link al video del proyecto" v-model="link" placeholder="Ingrese link al video"
          :rules="requiredRule"
          />
          <youtube v-if="link" :video-id="link.split('?v=')[1]"></youtube>
        </v-card-text>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
export default {
  props:{
    id:{
      type:String
    },
    cardTitle: {
      type: String,
      default: ''
    },
    preRegisteredValues: {
      type:Object
    }
  },
  data(){
    return {
      link:'',
      valid: false,
      requiredRule: [
        v => !!v || 'Este campo es obligatorio.'
      ],
    }
  },
  mounted(){
    if(this.preRegisteredValues!==undefined)
      this.link = this.preRegisteredValues.link
  },
  methods:{
    removeLink(){
      this.link=null
    },
    emitCardInfo(){
      this.$refs.cardForm.validate()
      if(this.valid){
        var event = 'getCardInfo'
        var card= {
          name: this.cardTitle,
          link: this.link,
          cardType: 2
        }
        if(this.$route.params.id && this.preRegisteredValues !== undefined){
          card.projectCardId= this.preRegisteredValues.projectCardId
        } 
        this.$emit(event, card)
      }
    }
  } 
}
</script>